exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[data-v-346c3f3a]::-webkit-inner-spin-button,input[data-v-346c3f3a]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number][data-v-346c3f3a]{-moz-appearance:textfield}", ""]);

// exports
